export default function OpenIntercom() {
  const Beacon = window.Beacon;
  if (typeof Beacon === "function") {
    Beacon("toggle");
  }
  // import $ from 'jquery';    // Intercom('onHide', function() { $('.livechat-popper').removeClass('open') });
  // var lcfForm = $(this).closest('form.tmly-lcf');

  // if ($(this).data('intercom-enforce')) {
  //   if (lcfForm.length && (!lcfForm[0].checkValidity())) {
  //     $(this).siblings('input.button').click();
  //     return false;
  //   }
  // }

  // $(this).addClass('open');

  // var isCookied = getCookie($(this).data('intercom-page'));

  // if ($(this).data('intercom-repeat')) {
  //   isCookied = false;
  // }

  // if ($(this).data('intercom-page') && !isCookied) {
  //   Intercom('onUnreadCountChange', function(unreadCount) {history.replaceState({}, document.title, lc_path);});

  //   history.replaceState({}, document.title, '/i/'+$(this).data('intercom-page')+lc_path);

  //   Intercom('update');

  //   setTimeout(() => {
  //     setCookie($(this).data('intercom-page'), 'true', 1000);
  //     history.replaceState({}, document.title, lc_path);
  //   }, 1500);

  //   setTimeout(function(){
  //     if (!$('.intercom-gradient').length) {
  //       Intercom('show');
  //     }
  //   }, 2001);

  // } else if ($(this).data('intercom-msg')) {
  //   Intercom('showNewMessage', $(this).data('intercom-msg'));
  // } else {
  //   Intercom('show');
  // }

  return false;
}
